import React from 'react'

import { Html } from '@application/Interfaces/Atoms/Html'
import { BlogButton } from '@application/Interfaces/Features/BlogButton'
import {
    BlogButtonType,
    BlogContentType,
    CardsWithTabComponentType,
    CBMComponentType,
    Component,
    NoteAlertType,
    TitleDescriptionAccordionType,
} from '@src/Application/Types/ComponentTypes'
import { STRAPI_COMPONENT_TYPES } from '@src/Core/Constants/PageConstants'

import { NoteAlert } from '../NoteAlert'
import { CardsWithTab, CBMCalculator, Content, TitleDescriptionAccordion, Wrapper } from './BlogContent.styled'
import { parseHtml } from './utils'

export const BlogContent = (
    props: Component & {
        components: (
            | BlogContentType
            | BlogButtonType
            | CBMComponentType
            | NoteAlertType
            | TitleDescriptionAccordionType
            | CardsWithTabComponentType
        )[]
        withWrapper?: boolean
    }
): JSX.Element => {
    const { components, withWrapper = false } = props

    const ElementWrapper = withWrapper ? Wrapper : React.Fragment

    return (
        <ElementWrapper>
            <Content>
                {components.map((component, i) => {
                    switch (component.strapi_component) {
                        case STRAPI_COMPONENT_TYPES.BLOG_BUTTON:
                            return (
                                <BlogButton
                                    {...(component as unknown as BlogButtonType)}
                                    key={`${component.strapi_component}-${i}`}
                                />
                            )
                        case STRAPI_COMPONENT_TYPES.BLOG_CONTENT:
                            return (
                                <Html
                                    key={`text-${i}`}
                                    content={parseHtml(
                                        (component as unknown as BlogContentType).content.data.childMarkdownRemark.html
                                    )}
                                ></Html>
                            )

                        case STRAPI_COMPONENT_TYPES.CBM_CALCULATOR:
                            return <CBMCalculator {...(component as unknown as CBMComponentType)} key={component.id} />

                        case STRAPI_COMPONENT_TYPES.NOTE_ALERT:
                            return <NoteAlert {...(component as unknown as NoteAlertType)} key={component.id} />
                        case STRAPI_COMPONENT_TYPES.TITLE_DESCRIPTION_ACCORDION:
                            return (
                                <TitleDescriptionAccordion
                                    {...(component as unknown as TitleDescriptionAccordionType)}
                                    key={component.id}
                                />
                            )

                        case STRAPI_COMPONENT_TYPES.CARD_WITH_TABS:
                            return (
                                <CardsWithTab
                                    {...(component as unknown as CardsWithTabComponentType)}
                                    key={component.id}
                                />
                            )
                    }
                })}
            </Content>
        </ElementWrapper>
    )
}
